import { render } from "./placeholder.vue?vue&type=template&id=a67a3e54"
import script from "./placeholder.vue?vue&type=script&setup=true&lang=js"
export * from "./placeholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/placeholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a67a3e54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a67a3e54', __exports__)) {
    console.log('reload')
    api.reload('a67a3e54', __exports__)
  }
  
  module.hot.accept("./placeholder.vue?vue&type=template&id=a67a3e54", () => {
    console.log('re-render')
    api.rerender('a67a3e54', render)
  })

}


export default __exports__